import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';
import { HelpOption, HelpOptions } from '../store/slices/help';

export const getHelpSpotlightCss = (
    helpOption: HelpOption,
    index: number,
    isLoggedIn: boolean,
): SxProps<Theme> => {
    switch (helpOption) {
    case HelpOptions.EXPLORE:
        switch (index) {
        case 0:
            return {
                top: {
                    xs: '0',
                    sm: '10px',
                    md: '11px',
                    lg: '7px',
                },
                right: {
                    xs: '-4px',
                    sm: '13px',
                    md: `${isLoggedIn ? '125' : '197'}px`,
                    lg: `${isLoggedIn ? '280' : '231'}px`,
                },
                left: {
                    xl: `calc(50% + ${isLoggedIn ? '588' : '640'}px)`,
                },
                width: {
                    xs: '80px',
                    lg: '90px',
                },
                height: {
                    xs: '80px',
                    lg: '90px',
                },
            };
        case 1:
            return {
                top: {
                    xs: '240px',
                    sm: '261px',
                },
                right: {
                    xs: '56px'
                },
                width: '136px',
                height: '70px',
                borderRadius: '35px'
            };
        case 2:
            return {
                top: {
                    xs: '148px',
                    sm: '163px',
                },
                left: {
                    xs: 0,
                    md: 'calc(50% - 460px)'
                },
                width: {
                    xs: '100%',
                    md: '920px'
                },
                height: '103px',
                borderRadius: '55px'
            };
        case 3:
            return {
                top: {
                    xs: '160px',
                    sm: '176px',
                },
                left: {
                    xs: 0,
                    md: 'calc(50% - 330px)'
                },
                width: {
                    xs: '100%',
                    md: '660px'
                },
                height: {
                    xs: '358px',
                    sm: '273px',
                },
                borderRadius: '55px'
            };
        default:
            return {};
        }
    case HelpOptions.SAVE_SPOTS:
        switch (index) {
        case 0:
            return {
                top: {
                    xs: 'calc(50% - 200px)',
                },
                right: {
                    xs: 'calc(50% - 200px)',
                },
                width: {
                    xs: '400px',
                },
                height: {
                    xs: '400px',
                },
            };
        case 1:
            return {
                top: {
                    xs: isLoggedIn ? 'calc(50% - 134px)' : 'calc(50% - 70px)',
                    sm: isLoggedIn ? 'calc(50% - 87px)' : 'calc(50% - 67px)',
                },
                left: {
                    xs: isLoggedIn ? 'calc(50% - 130px)' : 'calc(50% - 130px)',
                    sm: isLoggedIn ? 'calc(50% - 140px)' : 'calc(50%)',
                },
                width: {
                    xs: '260px',
                    sm: '280px',
                },
                height: {
                    xs: '104px',
                    sm: '140px',
                },
            };
        case 2:
            return {
                top: {
                    xs: 'calc(50% - 170px)',
                    sm: 'calc(50% - 180px)',
                },
                right: {
                    xs: 'calc(50% - 260px)',
                    sm: 'calc(50% - 240px)',
                },
                width: {
                    xs: '520px',
                    sm: '480px',
                },
                height: {
                    xs: '340px',
                    sm: '360px',
                },
                borderRadius: '50px',
            };
        case 3:
            return {
                top: {
                    xs: 'calc(50% - 575px)',
                    md: 'calc(50% - 525px)',
                },
                right: {
                    xs: 'calc(50% - 390px)',
                },
                width: {
                    xs: '780px',
                },
                height: {
                    xs: '1150px',
                    md: '1050px',
                },
                borderRadius: '50px',
            };
        default:
            return {};
        }
    case HelpOptions.GROW_NETWORK:
        switch (index) {
        case 0:
            return {
                top: {
                    xs: '310px',
                    sm: '330px',
                    md: '11px',
                    lg: '7px',
                },
                right: {
                    xs: '45px',
                    md: '10px',
                    lg: '10px',
                },
                left: {
                    xl: 'calc(50% + 730px)',
                },
                width: {
                    xs: '150px',
                    md: '188px',
                    lg: '220px',
                },
                height: {
                    xs: '150px',
                    md: '80px',
                    lg: '90px',
                },
                borderRadius: '40px'
            };
        case 1:
            return {
                top: {
                    xs: 'auto',
                    lg: '-10px',
                },
                right: {
                    xs: '-10px',
                    lg: '-18px',
                },
                bottom: {
                    xs: '-10px',
                },
                left: {
                    xl: 'calc(50% + 789px)',
                },
                width: {
                    xs: '130px',
                    sm: '190px',
                },
                height: {
                    xs: '130px',
                    sm: '190px',
                },
            };
        case 2:
            return {
                top: {
                    xs: 'auto',
                    lg: '245px',
                },
                right: {
                    xs: '45px',
                    lg: '40px',
                },
                bottom: {
                    xs: '250px',
                },
                left: {
                    xl: 'calc(50% + 730px)',
                },
                width: {
                    xs: '188px',
                    lg: '200px',
                },
                height: {
                    xs: '80px',
                    lg: '90px',
                },
                borderRadius: '40px'
            };
        case 3:
            return {
                top: {
                    xs: 'calc(50% - 400px)',
                    sm: 'calc(50% - 320px)',
                },
                right: {
                    xs: '20px',
                    sm: 'calc(50% - 360px)',
                },
                width: {
                    xs: 'calc(100% - 40px)',
                    sm: '720px',
                },
                height: {
                    xs: '440px',
                    sm: '300px',
                },
                borderRadius: '40px',
            };
        case 4:
            return {
                top: {
                    xs: 'calc(50% + 50px)',
                    sm: 'calc(50% - 20px)',
                },
                right: {
                    xs: '20px',
                    sm: 'calc(50% - 360px)',
                },
                width: {
                    xs: 'calc(100% - 40px)',
                    sm: '720px',
                },
                height: {
                    xs: '180px',
                    sm: '180px',
                },
                borderRadius: '40px',
            };
        default:
            return {};
        }
    }
};
